import React, { Fragment } from 'react'
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Typography,
} from '@material-ui/core'
import { ExpandMore } from '@material-ui/icons'
import { CoreConfigSection } from '../../../../interfaces/examiner/CoreConfig'
import ConfigFieldRow from './ConfigFieldRow'
import { ConfigurationsClasses } from './styles'

interface Props {
    section: CoreConfigSection | null
    expandedGroups: Record<string, boolean>
    onToggleGroup: (groupId: string) => void
    onFieldChange: (key: string, value: string) => void
    onFieldAction: (key: string) => void
    actionPending: boolean
    classes: ConfigurationsClasses
}

export default function ConfigSectionContent({
                                                 section,
                                                 expandedGroups,
                                                 onToggleGroup,
                                                 onFieldChange,
                                                 onFieldAction,
                                                 actionPending,
                                                 classes,
                                             }: Props) {
    if (!section) {
        return (
          <Typography color="textSecondary">
              Select a configuration section from the sidebar.
          </Typography>
        )
    }

    return (
      <Fragment>
          <div className={classes.contentHeader}>
              <Typography variant="h5">{section.title}</Typography>
          </div>

          {section.groups.map((group) => (
            <Accordion
              key={group.id}
              expanded={!!expandedGroups[group.id]}
              onChange={() => onToggleGroup(group.id)}
              className={classes.panel}
            >
                <AccordionSummary
                  expandIcon={<ExpandMore />}
                  className={classes.panelSummary}
                >
                    <Typography className={classes.panelTitle}>{group.title}</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.panelDetails}>
                    {group.description && (
                      <Typography className={classes.groupDescription}>
                          {group.description}
                      </Typography>
                    )}
                    {group.fields.map((field) => (
                      <ConfigFieldRow
                        key={field.key}
                        field={field}
                        onChange={onFieldChange}
                        onAction={onFieldAction}
                        actionPending={actionPending}
                        classes={classes}
                      />
                    ))}
                </AccordionDetails>
            </Accordion>
          ))}
      </Fragment>
    )
}
